import { useState, useEffect } from "react";
import moment from "moment";
import { fi } from "date-fns/locale";

export default (props) => {
  const { field, changeTrigger, defaultValue } = props;
  const [current, setCurrent] = useState(defaultValue ? defaultValue : "");

  const fieldChangeData = (e) => {
    const { value } = e.target;
    changeTrigger(field, value);
    setCurrent(value);
  };

  useEffect(() => {
    if (defaultValue) {
      // let date = moment(defaultValue).format("yyyy-MM-dd, hh:mm:ss");

      let date = new Date(defaultValue);
      if (date == "Invalid Date") {
        date = new Date();
        let localISOTime = date.toISOString().slice(0, 19);
        setCurrent(localISOTime);
      }

      let localISOTime = moment.utc(defaultValue).toISOString().slice(0, 19);
      setCurrent(localISOTime);
    }
  }, [defaultValue]);

  return (
    <div className="row justify-content-center">
      <div className="col-md-8">
        <form>
          <div className="form-group">
            <label htmlFor="name">
              {" "}
              {field?.title?.content || field.field_name}
              {!field.NULL && <span style={{ color: "red" }}> *</span>}
            </label>
            <input
              type="datetime-local"
              className="form-control"
              placeholder=""
              onChange={fieldChangeData}
              value={current}
            />
          </div>
        </form>
      </div>
    </div>
  );
};
